import { getTablePartController, getTPCommandPanel } from '../../../../BaseEditor';
import { GridTemplate } from './styles';
import BodyComponent from './body';
import HeaderComponent from './header';

const newRecordData = () => ({
  kdb: null,
  payer: null,
  is_basic: false,
  proportion: 1,
});

export default getTablePartController(
  GridTemplate,
  BodyComponent,
  newRecordData,
  getTPCommandPanel(),
  HeaderComponent,
);
